import { Entity } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { TopRankIcon } from '@terminal/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GeographicStepperSection } from '../geographic-stepper-section/GeographicStepperSection';
import { GeoSourceEvidenceSection } from '../source-evidence-section/GeoSourceEvidenceSection';
import styles from './GeoExposureDetails.module.scss';

export interface GeoExposureDetailsProps {
  entity: Entity;
  targetName: string;
  targetType: 'country' | 'region';
  title: string;
  rankTitle: string;
  description: string;
  rank: number;
  evidence?: string[] | null;
  sourceEvidence?: string | null;
  withDivider?: boolean;
}

export const loadingSkeletonAreas = [
  { styles: { width: '100%', height: '40px' } },
  { styles: { width: '100%', height: '100px' } },
];

export const GeoExposureDetails = ({
  entity,
  targetName,
  targetType,
  title,
  rankTitle,
  description,
  rank,
  evidence,
  sourceEvidence,
  withDivider,
}: GeoExposureDetailsProps) => {
  const { t } = useTranslation(['widget']);
  return (
    <div className={styles.root}>
      <GeographicStepperSection
        entity={entity}
        targetName={targetName}
        targetType={targetType}
        title={title}
        activeIndex={0}
        description={description}
      />
      <div className={styles.sectionRow}>
        <div className={styles.titleBase}>{rankTitle}</div>
        <div className={styles.styledRankWrapper}>
          <div className={styles.rankContainer}>
            <div className={styles.rankLabel}>
              {t(
                'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.current'
              )}
            </div>
            <div className={styles.rankFlexRow}>
              <TopRankIcon rank={rank} />
            </div>
          </div>
        </div>
      </div>
      <ErrorBoundaryWrapper>
        <GeoSourceEvidenceSection
          evidence={evidence ?? []}
          sourceEvidence={sourceEvidence ?? null}
        />
      </ErrorBoundaryWrapper>
      {withDivider ? <div className={styles.horizontalDivider} /> : null}
    </div>
  );
};
